import React from 'react'

import { graphql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import Typography from '@material-ui/core/Typography'

import { withSnackbar } from 'notistack'
import { withContext } from '../../context'
import { UPDATE_USER } from '../../graphql/mutations'
import PickLocation from '../../components/PickLocation'
import LocationListSignUp from './LocationListSignUp'

export const LocationSignUp = (props) => {
  const {
    locations,
    heroConfig,
    handleSetLocations,
    handleSetDeleteLocations
  } = props
  return (
    <React.Fragment>
      {!locations.length > 0 && (
        <Typography>เพิ่มสถานที่ตั้งเพื่อให้ผู้อื่นเข้าถึง</Typography>
      )}
      {locations.length < heroConfig.locationCount && (
        <PickLocation
          heroConfig={{ radius: 5000 }}
          setLocation={handleSetLocations}
        />
      )}
      {locations.length > 0 && (
        <LocationListSignUp
          locations={locations}
          setUpdateLocations={handleSetLocations}
          setDeleteLocations={(locationIndex) =>
            handleSetDeleteLocations(locationIndex)
          }
        />
      )}
    </React.Fragment>
  )
}

export default compose(
  withRouter,
  withApollo,
  withSnackbar,
  withContext,
  graphql(UPDATE_USER, { name: 'UpdateUser' })
)(LocationSignUp)



// WEBPACK FOOTER //
// ./src/components/LocationSignUp/index.js